import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";

import * as actions from "./actions";
import * as types from "./types";
import * as services from "./service";
import * as alert from "../alert/actions";
import * as actionTypes from "./actionTypes";

function* postWorkflowsSaga(action: types.PostWorkflowRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IWorkflowSuccess | types.IApiError> = yield call(services.postWorkflows, action.payload);
        if (response.status === 201) {
            let dataPayload = response.data as types.IWorkflowSuccess;
            yield put(
                actions.postWorkFlowsSuccess({
                    workflow: dataPayload
                })
            );

            yield put(alert.enqueueSnackbar({ message: `Job triggered successfully. Timestamp: ${timestamp}`, options: { variant: "success" } }));
        }

        //Show IApiError
        if (response.status !== 201) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}. Timestamp: ${timestamp}`;
            yield put(
                alert.enqueueSnackbar({
                    message: errmsg,
                    options: { variant: "error" },
                })
            );
            yield put(
                actions.postWorkFlowsFailure({
                    error: apiError,
                })
            );
        }
    } catch (e: any) {
        yield put(
            actions.postWorkFlowsFailure({
                error: e.message,
            })
        );
    }
}

/*
  Watcher saga - intercept the action fired from view
  Starts worker saga on latest dispatched `FETCH_ACCESSCONTROL_REQUEST` action.
  Allows concurrent increments.
*/
function* workFlowSaga() {
    yield takeEvery(actionTypes.POST_WORKFLOW_REQUEST, postWorkflowsSaga);
}

function* workFlowsSaga() {
    yield all([
        workFlowSaga(),])
}

export default workFlowsSaga;